"use strict";import e from"./src/scale-large.css.js";import{Theme as r}from"./src/Theme.js";import"./core.js";r.registerThemeFragment("large","scale",e);
//# sourceMappingURL=scale-large.js.map
